module.exports = __webpack_public_path__ + "media/images/help/about/icon-reason-2-b03c2f6aa662601af939b39d2435dad4.svg";